<template>
  <div>
    <div v-if="initialLoading" class="tw-flex tw-justify-center tw-p-4 tw-items-center">
      <BaseInfinityLoading class="tw-w-14" />
    </div>
    <div v-else class="tw-mt-4">
      <!-- Title -->
      <div class="tw-text-base tw-text-infinity-secondary-text tw-mb-3">
        <span class="tw-font-medium">{{ soundkit.itemsCount }} Files</span> in the pack
      </div>
      <SoundkitItem v-for="item in items" :name="item.filename" :key="item.id" :soundkit="soundkit" />
      <div v-if="hasMore" @click="loadMore" class="tw-mt-2 tw-flex tw-items-center tw-inline-block tw-text-sm tw-text-infinity-tertiary-text">
        <template v-if="loading">
          <font-awesome-icon icon="spinner" class="tw-mr-2" spin />
          <span>Loading</span>
        </template>
        <span class="tw-underline tw-cursor-pointer" v-else>View More</span>
      </div>
    </div>
  </div>
</template>
<script>
import InfiniteLoading from "vue-infinite-loading";
import SoundKit from "../../../models/soundkit";
import SoundkitItem from "./soundkit-item";
import SoundKitRepository from "../../../mixins/soundkit-repository";
import BaseInfinityLoading from "../../base/base-infinity-loading";

export default {
  components: { BaseInfinityLoading, SoundkitItem, InfiniteLoading },
  mixins: [SoundKitRepository],
  props: {
    soundkit: {
      type: SoundKit,
      required: true
    }
  },
  mounted() {
    this.getSoundkitItems();
  },
  data() {
    return {
      itemsPage: 1,
      items: [],
      initialLoading: true,
      hasMore: false,
      loading: false
    };
  },
  methods: {
    async getSoundkitItems() {
      try {
        this.loading = true
        const response = await this.getUserSoundkitItems(this.soundkit.id, this.itemsPage, 10);
        this.items.push(...response.data.items);
        this.hasMore = !!response.data.cursor?.next
      } catch {}
      finally {
        this.initialLoading = false
        this.loading = false
      }
      this.itemsPage++;
    },
    loadMore() {
      this.getSoundkitItems();
    }
  }
};
</script>
